import Vue from "vue";
import "./plugins/axios";
import "./plugins/bootstrap-vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "./components/common/index";
import "./plugins/wApi/index";
import "./plugins/mask";
import "./plugins/vee-validate";
import "./plugins/common";
import "./style/index.scss";
import "./mixins/boolConfirm";
import ConfirmBtn from "./components/ui/ConfirmBtn.vue";
import DropdownSelect from "./components/ui/DropdownSelect.vue";
import Resizable from './directive/resizable';

import VueFriendlyIframe from 'vue-friendly-iframe';
import { i18n } from '@/plugins/lang';

declare global {
  interface Window {
    editor: any;
  }
}

Vue.config.productionTip = false;

// console.log("ConfirmBtn", ConfirmBtn);
Vue.component("ConfirmBtn", ConfirmBtn);
Vue.component("DropdownSelect", DropdownSelect);
Vue.directive('resizable', Resizable);


Vue.use(VueFriendlyIframe);

const vm = new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
